import * as React from 'react';
import styled, { withTheme } from 'styled-components';
import { Component } from 'react';
import { propStyles } from '@kurtosys/ksys-portal-components/build/utils/propStyles';
import { ShareclassColumn } from './ShareclassRows';
import { observer, inject } from 'mobx-react';
import Icon from './Icon';

const Button = styled<any, any>('button')`
    ${propStyles};
    all: unset;
`;

Button.defaultProps = {};

@inject('accessibilityStore')
@observer
class ShareclassRowExpander extends Component<any, any> {
    render() {
        const {
            theme,
            rowExpanderConfig,
            shareClass,
            accessibilityStore,
        } = this.props;
        const fileName = shareClass.expanded
            ? (rowExpanderConfig && rowExpanderConfig.collapseIconFileName) ||
              'CollapseIcon'
            : (rowExpanderConfig && rowExpanderConfig.expandIconFileName) ||
              'ExpandIcon';

        return (
            <ShareclassColumn
                paddingX="0"
                width="40px"
                textAlign="center"
                {...theme.ShareclassColumnExpand}
            >
                <Button
                    aria-label={accessibilityStore.buttonAccessibilityValue(
                        'ShareclassRowExpander'
                    )}
                    aria-expanded={shareClass.expanded}
                    {...theme.ShareclassColumnExpandButton}
                >
                    <Icon
                        iconSize="1.4em"
                        fileName={fileName}
                        {...theme.ShareclassColumnExpandIcon}
                        accessibilityContext={`for share class identified by ${shareClass.shareClass.clientCode}`}
                    />
                </Button>
            </ShareclassColumn>
        );
    }
}

export default withTheme(ShareclassRowExpander) as any;



// WEBPACK FOOTER //
// ./src/Components/ShareclassRowExpander.tsx